import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
const InputSearch = ({ children }) => {
  return (
    <div className="input-to-search">
        {children}
      <FontAwesomeIcon icon={faSearch} />
    </div>
  );
};

export default InputSearch;
